import { createAction } from 'redux-actions';

import * as ACTION from './constants';

export const getReturns = createAction(ACTION.GET_RETURNS.REQUEST);
export const clearState = createAction(ACTION.CLEAR_STATE);
